import { useState, useEffect } from "react";
import { FormGroup, Input, Label } from "reactstrap";
import { useOutletContext } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';

import { translations } from './../../i18/translations.js';

const JuniorDataForm = ({ junior, onChange }) => {
    const [userData, setUserData] = useState(junior);
    const {lang} = useOutletContext();

    useEffect(() => {
        setUserData(junior);
    }, [junior]);

    const handleUserDataInputChange = (e) => {
        const {id, value, type, checked} = e.target;

        setUserData((prevData) => {
            const newContent = {
                ...prevData,
                [id]: type === "checkbox" ? checked : value
            };
            onChange(newContent);
            return newContent;
        });
    };

    return (
            <>
            {userData && (
                                    <>
                                    <FormGroup floating>
                                        <Input id="nameprefix" type="text" value={userData.nameprefix || ""} onChange={handleUserDataInputChange} maxLength={30} />
                                        <Label for="nameprefix">{translations[lang].name_prefix_label}</Label>
                                    </FormGroup>
                                    <FormGroup floating>
                                        <Input id="fullname" type="text" value={userData.fullname || ""} onChange={handleUserDataInputChange} maxLength={100} />
                                        <Label for="fullname">{translations[lang].fullname_label}</Label>
                                    </FormGroup>
                                    <FormGroup floating>
                                        <Input id="email" type="text" value={userData.email || ""} onChange={handleUserDataInputChange} autoComplete="email" maxLength={200} />
                                        <Label for="email">{translations[lang].workspace_email_label}</Label>
                                    </FormGroup>
                                    
                                    {userData.id !== "-1" && (
                                                                <FormGroup switch>
                                                                    <Input id="changePwd" type="switch" checked={userData.changePwd || false} onChange={handleUserDataInputChange} />
                                                                    <Label for="changePwd">{translations[lang].change_password}</Label>
                                                                </FormGroup>
                                                )}
                                    
                                    {(userData.changePwd || userData.id === -1) && (
                                                                <>
                                                                <FormGroup floating>
                                                                    <Input id="pwd" type="password" value={userData.pwd || ""} onChange={handleUserDataInputChange} maxLength={50} />
                                                                    <Label for="pwd">{translations[lang].pwd_label}</Label>
                                                                </FormGroup>
                                                                <FormGroup floating>
                                                                    <Input id="pwdRe" type="password" value={userData.pwdRe || ""} onChange={handleUserDataInputChange} maxLength={50} />
                                                                    <Label for="pwdRe">{translations[lang].pwd_re_label}</Label>
                                                                </FormGroup>
                                                                </>
                                                )}
                                    
                                    <FormGroup floating>
                                        <Input id="institute" type="text" value={userData.institute || ""} onChange={handleUserDataInputChange} maxLength={200} />
                                        <Label for="institute">{translations[lang].workspace_label}</Label>
                                    </FormGroup>
                                    <FormGroup floating>
                                        <Input id="address" type="text" value={userData.address || ""} onChange={handleUserDataInputChange} autoComplete="street-address" maxLength={200} />
                                        <Label for="address">{translations[lang].workspace_address_label}</Label>
                                    </FormGroup>
                                    <FormGroup floating>
                                        <Input id="phone" type="text" value={userData.phone || ""} onChange={handleUserDataInputChange} autoComplete="tel" maxLength={200} />
                                        <Label for="phone">{translations[lang].workspace_phone_label}</Label>
                                    </FormGroup>
                                    
                                    <FormGroup switch>
                                        <Label for="statement">
                                            <FontAwesomeIcon icon={faExclamationCircle} />
                                            <strong>{translations[lang].user_statement_label}: </strong>{translations[lang].junior_statement}
                                        </Label>
                                        <Input id="statement" type="switch" checked={userData.statement} onChange={handleUserDataInputChange} />
                                    </FormGroup>
                                    </>
                                )}
            </>
            );
};

export default JuniorDataForm;
